import React, { useEffect, useState } from "react";
import { FiFilter } from "react-icons/fi";
import AllOrders from "./TempTwoTabs/allOrders";
import Pending from "./TempTwoTabs/pending";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../utils/redux/hooks";
import { RootState } from "../../../utils/redux/store";
import GoBack from "../../GoBack";

const items = [
  "All Customers",
  "Pending",
  "Accepted",
  "InProgress",
  "Track",
  // "In Dispute",
  "Completed",
  // "Declined",
  "Cancelled",
];

const TempTwo = () => {
  const [selectedTab, setSelectedTab] = useState(items[0]);

  const navigate = useNavigate();
  const customerOrders = useAppSelector(
    (store: RootState) => store.user.customerOrders
  );

  const viewWallet: any = useAppSelector(
    (store: RootState) => store.user.viewWallet
  );

  const viewCustomer: any = useAppSelector(
    (store: RootState) => store.user.viewCustomer
  );

  const [isFilterClicked, setIsFilterClicked] = useState(false);
  const [filterRef, setFilterRef] = useState<null | any>(null);
  useEffect(() => {
    setFilterRef(document.getElementById("filter-container"));
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (filterRef && !filterRef.contains(event.target)) {
        setIsFilterClicked(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [filterRef]);

  const toggleFilter = () => {
    setIsFilterClicked((prev) => !prev);
  };

  console.log("viewcustomersdf", viewCustomer);
  return (
    <div className="px-0 lg:px-3">
      <div className="flex flex-col mb-6">
        <div className="hidden lg:flex flex-col lg:flex-row justify-between gap-4 items-center">
          <div className="flex  lg:flex-row  lg:gap-4 sm:gap-0 text-[#88087B] items-center">
            <GoBack />
            <p className="font-roboto text-2xl lg:text-3xl font-medium leading-normal">
              {viewCustomer?.firstName} {viewCustomer?.lastName}
            </p>
            <p className="font-roboto border-l-2 pl-2 border-black text-3xl lg:text-3xl font-medium leading-normal">
              {viewCustomer?.email} 
            </p>
            <p className="border-l-2 border-[#000] px-2 font-roboto text-base sm:text-lg font-medium leading-normal">
              Rating: {viewCustomer?.averageRating || 0}
            </p>
            <p
              onClick={() => {
                // navigate(`/customers5`);
              }}
              className="border border-[#000] px-1 font-roboto text-base sm:text-lg font-medium leading-normal"
            >
              Wallet Balance: ₦{" "}
              {viewCustomer?.wallet?.availableBalance.toLocaleString()}
            </p>
          </div>

          <div className=" relative" id="filter-container">
            <FiFilter
              size={20}
              className="text-[#88087B] cursor-pointer"
              onClick={toggleFilter}
            />
            {isFilterClicked && (
              // <div className="flex lg:flex-wrap border-b-[0.1rem] border-[#000] gap-4 lg:gap-0 lg:justify-between overflow-x-auto lg:overflow-hidden mt-3">
              <div className="absolute top-5 right-0 space-y-2 border w-max p-6 bg-white rounded-sm">
                {items.map((item, index) => (
                  <p
                    key={index}
                    className={`flex py-1 justify-between gap-3 hover:border-b-2 hover:border-[#88087B] font-roboto lg:text-base text-sm font-medium leading-normal cursor-pointer whitespace-nowrap ${
                      item === selectedTab
                        ? "border-b-2 border-[#88087B]"
                        : // ""
                          ""
                    }`}
                    onClick={() => {
                      setSelectedTab(item);
                      toggleFilter();
                    }}
                  >
                    <span>{item} </span>
                    <span className="bg-[#88087B]  text-[#fff] text-sm px-1 rounded-sm">
                      {item === "All Customers"
                        ? customerOrders?.length
                        : item === "Pending"
                        ? customerOrders?.filter(
                            (order) => order.status === "PENDING"
                          )?.length
                        : item === "Accepted"
                        ? customerOrders?.filter(
                            (order) => order.status === "ACCEPTED"
                          )?.length
                        : item === "InProgress"
                        ? customerOrders?.filter(
                            (order) => order.status === "INPROGRESS"
                          )?.length
                        : item === "Completed"
                        ? customerOrders?.filter(
                            (order) => order.status === "COMPLETED"
                          )?.length
                        : 0}
                    </span>
                  </p>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="flex lg:hidden flex-col text-[#88087B] w-full ">
          <div className="flex sm:flex-col justify-between w-full items-start">
            <p className="font-roboto text-3xl lg:text-3xl font-medium leading-normal">
              {viewCustomer?.firstName} {viewCustomer?.lastName}
            </p>
            <p className="font-roboto border-r text-xl lg:text-3xl font-medium leading-normal">
              {viewCustomer?.email} 
            </p>
            <p className=" border-0  font-roboto text-base sm:text-lg font-medium leading-normal">
              Rating: 4.8
            </p>
            {/* for mobie  */}
            <div className=" ml-auto mb-8 relative" id="filter-container">
              <FiFilter
                size={20}
                className="text-[#88087B] cursor-pointer"
                onClick={toggleFilter}
              />
              {isFilterClicked && (
                // <div className="flex lg:flex-wrap border-b-[0.1rem] border-[#000] gap-4 lg:gap-0 lg:justify-between overflow-x-auto lg:overflow-hidden mt-3">
                <div className="absolute top-5 right-0 space-y-2 border w-max p-6 bg-white rounded-sm">
                  {items.map((item, index) => (
                    <p
                      key={index}
                      className={`flex py-1 justify-between gap-3 hover:border-b-2 hover:border-[#88087B] font-roboto lg:text-base text-sm font-medium leading-normal cursor-pointer whitespace-nowrap ${
                        item === selectedTab
                          ? "border-b-2 border-[#88087B]"
                          : // ""
                            ""
                      }`}
                      onClick={() => {
                        setSelectedTab(item);
                        toggleFilter();
                      }}
                    >
                      <span>{item} </span>
                      <span className="bg-[#88087B]  text-[#fff] text-sm px-1 rounded-sm">
                        {item === "All Customers"
                          ? customerOrders?.length
                          : item === "Pending"
                          ? customerOrders?.filter(
                              (order) => order.status === "PENDING"
                            )?.length
                          : item === "Accepted"
                          ? customerOrders?.filter(
                              (order) => order.status === "ACCEPTED"
                            )?.length
                          : item === "In Progress"
                          ? customerOrders?.filter(
                              (order) => order.status === "INPROGRESS"
                            )?.length
                          : item === "Completed"
                          ? customerOrders?.filter(
                              (order) => order.status === "COMPLETED"
                            )?.length
                          : 0}
                      </span>
                    </p>
                  ))}
                </div>
              )}
            </div>
          </div>

          <p
            onClick={() => {
              navigate(`/provider5`);
            }}
            className="border border-[#000] px-2 font-roboto text-base sm:text-xl font-medium leading-normal"
          >
            Wallet Balance: ₦{" "}
            {viewWallet?.wallet?.availableBalance.toLocaleString()}
          </p>
        </div>
        {/* <div className="flex lg:flex-wrap border-b-[0.1rem] border-[#000] gap-4 lg:gap-0 lg:justify-between overflow-x-auto lg:overflow-hidden mt-3">
          {items.map((item, index) => (
            <p
              key={index}
              className={`font-roboto lg:text-base text-sm font-medium leading-normal cursor-pointer whitespace-nowrap ${
                index === selectedTab ? "border-b-2 border-[#88087B]" : ""
              }`}
              onClick={() => setSelectedTab(index)}
            >
              {item}
              <span className="bg-[#88087B] text-[#fff] text-xs lg:text-sm px-0.5 lg:px-1 rounded-sm">
                {item === "All Orders"
                  ? customerOrders?.length
                  : item === "Pending"
                  ? customerOrders?.filter(
                      (order) => order.status === "PENDING"
                    )?.length
                  : item === "Accepted"
                  ? customerOrders?.filter(
                      (order) => order.status === "ACCEPTED"
                    )?.length
                  : 0}
              </span>
            </p>
          ))}
        </div> */}
        {/* {items.map((item, index) => (
          <div
            key={index}
            className={index === selectedTab ? "block" : "hidden"}
          >
            {index === 0 && <AllOrders />}
            {index === 1 && <Pending />}
            {index === 2 && <div>Accepted</div>}
            {index === 3 && <div>In Progress</div>}
            {index === 4 && <div>In Dispute</div>}
            {index === 5 && <div>Completed</div>}
            {index === 6 && <div>Declined</div>}
            {index === 7 && <div>Cancelled</div>}
          </div>
        ))} */}
        <AllOrders selectedTab={selectedTab} user={viewCustomer} />
      </div>
    </div>
  );
};

export default TempTwo;
